// extracted by mini-css-extract-plugin
export var banner = "_18-0";
export var icon = "_18-1";
export var message = "_18-2";